// src/App.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './layout/Layout';
import Hero from './sections/Hero';
import About from './sections/About';
import Services from './sections/Services';
import Contact from './sections/Contact';
import PrivacyPolicy from './sections/PrivacyPolicy';

function App() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Layout>
            <Hero />
            <About />
            <Services />
            <Contact />
          </Layout>
        }
      />
      <Route
        path="/privacy-policy"
        element={
          <Layout>
            <PrivacyPolicy />
          </Layout>
        }
      />
    </Routes>
  );
}

export default App;